var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('a',{staticClass:"hidden-lg-and-up",attrs:{"target":"_blank","href":_vm.getLink(_vm.hotelData)}},[_c('span',{staticClass:"icon-whatsapp",staticStyle:{"font-size":"36px"},attrs:{"id":"whatsapp"}})]),_vm._v(" "),_c('a',{staticClass:"hidden-md-and-down",attrs:{"target":"_blank","href":_vm.getLink(_vm.hotelData)}},[_c('span',{staticClass:"icon-whatsapp",staticStyle:{"font-size":"36px"},attrs:{"id":"whatsapp"}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6e5ccf00","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/WhatsappHotel.vue
// module id = 560
// module chunks = 2